import React, { useState } from 'react';
import { Button, Modal } from "react-bootstrap";
import request from '../../../services/request';
import Select from "react-select";
import MultiSelect from "../../fields/MultiSelect";

export default function AuthModal(props) {
    const [showModal, setShowModal] = useState(false);
    const [options, setOptions] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);

    const uploadFile = () => {
        request({
            method: "post",
            url: props.requestTo,
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
        }).then((response) => {
            if (response.responseStatus === "SUCCESS") {
                setShowModal(false)
            }
        })
    }

    let modal = <Modal className="modal fade" show={showModal}>
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title">Yetki Ekle</h5>
                <Button
                    variant=""
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    onClick={() => setShowModal(false)}
                >
                    <span>×</span>
                </Button>
            </div>
            <div className="modal-body">
                <div className="row">
                    <MultiSelect
                        name={"auth"}
                        label={"Yetkiler"}
                        colNumber={"12"}
                        options={options}
                        selectedOptions={selectedOptions}
                        setSelectedOptions={setSelectedOptions}
                    />
                </div>
            </div>
            <div className="modal-footer">
                <Button
                    type="button"
                    className="submit btn btn-primary float-right btn-sm"
                    onClick={() => uploadFile()}
                >
                    Tamamla
                </Button>
            </div>
        </div>
    </Modal>;
    let btn = React.Children.only(props.children);
    let content = React.cloneElement(
        btn,
        {
            onClick: () => {
                setShowModal(true)
            },
        },
        btn.props.children
    );
    return (
        <>
            {modal}
            {content}
        </>
    )
}
